export default __webpack_public_path__ + "static/media/dis2023-slides.4afb4dc6.pdf";